import {default_area, default_params} from './state';

/**
 * Establecer un valor para la variable areas.
 */
export function setAreas(state, areas) {
    state.areas = areas;
}

/**
 * Establecer un valor para la variable area.
 */
export function setArea(state, area) {
    state.area = area;
}

/**
 * Establecer un valor para el atributo code de la variable area.
 */
export function setCodeToArea(state, code) {
    state.area.code = code;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable companies.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Establecer el valor por defecto de params.
 */
export function resetParams(state) {
    state.params = default_params();
    state.areas = {data: []};
}

/**
 * Establecer el valor por defecto de area.
 */
export function resetArea(state) {
    state.area = default_area();
}

/**
 * Establecer un valor para el atributo show la variable modal.
 */
export function setModalShow(state, show) {
    state.modal.show = show;
}

/**
 * Restablecer el valor del atributo page de la variable params.
 */
export function resetPageParams(state) {
    state.params.page = 1;
}

/**
 * Establecer un valor para el atributo show de la variable modal_upload.
 */
export function setShowToModalUpload(state, show) {
    state.upload = {file: null};
    state.modal_upload.show = show;
}

/**
 * Mutación que establece las áreas padre.
 *
 * @param {*} state.areasFather - Estado de las áreas padre.
 * @return {void}
 * @author Brandon Torres
 */
export function setAreasFather(state, areasFather) {
    state.areasFather = areasFather;
}

/**
 * Mutación que establece las áreas hijas.
 * @param {*} state.areasTree - Estado de las áreas hijas.
 * @return {void}
 * @author Brandon Torres
 */
export function setAreasTree(state, areasTree) {
    state.areasTree = areasTree;
}
